/* eslint-disable no-nested-ternary */
import { generatePath } from 'react-router-dom';

import { processMenu } from '../utils/menu';

const rootInsightsPath = '/d/i/:businessEntityUuid';
const insightsPath = `${rootInsightsPath}/dashboard`;

/**
 * Get the insights menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  ldFlags: Array
 *  order: number
 * }} params
 * @returns {object}
 */
export function getInsightsMenu({
  businessEntityUuid,
  ldFlags,
  order
}) {
  const { enableInsightsUIMFE } = ldFlags;
  return processMenu({
    show: enableInsightsUIMFE,
    title: 'Insights',
    icon: '/s2/icon/insights-nav-icon.svg',
    path: generatePath(insightsPath, { businessEntityUuid }),
    isBeta: true,
    order
  });
}
